import { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import PRIVILEGES from '../constants/privileges';
import SkeletonPage from '../modules/skeleton/SkeletonPage';
import { RBACRoute } from './RBACRoute';

const PurchaseOrder = lazy(() => import('../modules/purchase-order'));

const PurchaseOrderTable = lazy(
  () => import('../modules/purchase-order/pages/PurchaseOrderTable')
);
const PurchaseOrderDetails = lazy(
  () => import('../modules/purchase-order/pages/PurchaseOrderDetails')
);
const CreatePurchaseOrder = lazy(
  () => import('../modules/purchase-order/pages/CreatePurchaseOrder')
);
const EditPurchaseOrder = lazy(
  () => import('../modules/purchase-order/pages/EditPurchaseOrder')
);
const ClonePurchaseOrder = lazy(
  () => import('../modules/purchase-order/pages/ClonePurchaseOrder')
);

const ConvertToBillPurchaseOrder = lazy(
  () => import('../modules/po-bills/pages/CreatePoBill')
);

const EditPoBill = lazy(() => import('../modules/po-bills/pages/EditPoBill'));
const ViewPoBill = lazy(() => import('../modules/po-bills/pages/ViewPoBill'));

const PurchaseOrderRoutes = (
  <>
    <Route
      path="purchases/purchase-order"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <PurchaseOrder />
        </Suspense>
      }
    >
      <Route
        path="new/create"
        element={
          <Suspense fallback={<SkeletonPage />}>
            <CreatePurchaseOrder />
          </Suspense>
        }
      />
      <Route
        path=":poId/edit"
        element={
          <RBACRoute privileges={[PRIVILEGES.COMMON.PURCHASE_ORDER_UPDATE]}>
            <Suspense fallback={<SkeletonPage />}>
              <EditPurchaseOrder />
            </Suspense>
          </RBACRoute>
        }
      />
      <Route
        path=":poId/clone"
        element={
          <RBACRoute privileges={[PRIVILEGES.COMMON.PURCHASE_ORDER_CLONE]}>
            <Suspense fallback={<SkeletonPage />}>
              <ClonePurchaseOrder />
            </Suspense>
          </RBACRoute>
        }
      />
      <Route
        path=":poId/:action/:details?"
        element={
          <RBACRoute
            privileges={[PRIVILEGES.COMMON.PURCHASE_ORDER_DETAILS_VIEW]}
          >
            <Suspense fallback={<SkeletonPage />}>
              <PurchaseOrderDetails />
            </Suspense>
          </RBACRoute>
        }
      />
      <Route
        path="generate-bill"
        element={
          <Suspense fallback={<SkeletonPage />}>
            <ConvertToBillPurchaseOrder />
          </Suspense>
        }
      />
      <Route
        path="edit-bill"
        element={
          <RBACRoute privileges={[PRIVILEGES.COMMON.PO_BILLS_UPDATE]}>
            <Suspense fallback={<SkeletonPage />}>
              <EditPoBill />
            </Suspense>
          </RBACRoute>
        }
      />

      <Route
        path="view-bill"
        element={
          <RBACRoute privileges={[PRIVILEGES.COMMON.PO_BILLS_DETAILS_VIEW]}>
            <Suspense fallback={<SkeletonPage />}>
              <ViewPoBill />
            </Suspense>
          </RBACRoute>
        }
      />
      <Route
        path=""
        element={
          <RBACRoute privileges={[PRIVILEGES.COMMON.PURCHASE_ORDER_VIEW]}>
            <Suspense fallback={<SkeletonPage />}>
              <PurchaseOrderTable />
            </Suspense>
          </RBACRoute>
        }
      />
    </Route>
  </>
);

export default PurchaseOrderRoutes;
